import { createContext } from 'react';

export const DataTypeContext = createContext();